import { render, staticRenderFns } from "./EndShiftTransfer.vue?vue&type=template&id=cbc4f22c"
import script from "./EndShiftTransfer.vue?vue&type=script&lang=js"
export * from "./EndShiftTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports